module.exports = __webpack_public_path__ + "img/Airbnb-Pomodoro-Stretch.d9945627.jpg";